import { useState } from "react";
import { Box, Paper, Tab, Tabs } from "@material-ui/core";
import { FormRequestFormComponent } from "./form-request.form.component";
import { ListAvailableForms } from "./list-available-forms.tab";
import { ListMyRequests } from "./list-my-requests.tab";


function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

export function FormsDashboard() {
	const [openForm, setOpenForm] = useState();
  const [editForm, setEditForm] = useState();
	const [tab, setTab] = useState(0);

	const handleChange = (event, newValue) => {
		setTab(newValue);
	};


  if (editForm) {
    return (
      <FormRequestFormComponent
        form={editForm.availability.form}
        onCancel={() => setEditForm(undefined)}
        editMode
        requestId={editForm.id}
        onAfterSubmit={() => {
          setEditForm(undefined)
          setTab(1);
        }}
        currentValues={editForm.fields}
        availabilityId={editForm.availability.id}
      />
    )
  }
	if (openForm) {
		return (
			<FormRequestFormComponent
				form={openForm.form}
				onCancel={() => setOpenForm(undefined)}
				onAfterSubmit={() => {
					setOpenForm(undefined)
					setTab(1);
				}}
				availabilityId={openForm.id}
			/>
		)
	} else return (
		<Box sx={{ width: '100%' }}>
			<Paper>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
						<Tab label="Formulários Disponíveis" />
						<Tab label="Minhas Requisições" />
					</Tabs>
				</Box>
				<CustomTabPanel value={tab} index={0}>
					<ListAvailableForms
						onRowSelected={row => setOpenForm(row)}
					/>
				</CustomTabPanel>
				<CustomTabPanel value={tab} index={1}>
					<ListMyRequests onEdit={a => setEditForm(a)} />
				</CustomTabPanel>
			</Paper>
		</Box>
	)
}





